import {
    FETCH_TRIPS_REQUEST,
    FETCH_TRIPS_SUCCESS,
    FETCH_TRIPS_FAILURE,
    FETCH_TRIPS_POLICIES_REQUEST,
    FETCH_TRIPS_POLICIES_SUCCESS,
    FETCH_TRIPS_POLICIES_FAILURE,
    FETCH_TRIPS_CLAIMS_REQUEST,
    FETCH_TRIPS_CLAIMS_SUCCESS,
    FETCH_TRIPS_CLAIMS_FAILURE,
    FETCH_TRIPS_CLAIMS_TODAY_REQUEST,
    FETCH_TRIPS_CLAIMS_TODAY_SUCCESS,
    FETCH_TRIPS_CLAIMS_TODAY_FAILURE,
    FETCH_TRIPS_CHECK_CLAIMS_REQUEST,
    FETCH_TRIPS_CHECK_CLAIMS_SUCCESS,
    FETCH_TRIPS_CHECK_CLAIMS_FAILURE,
    FETCH_TRIPS_FORECASTS_REQUEST,
    FETCH_TRIPS_FORECASTS_SUCCESS,
    FETCH_TRIPS_FORECASTS_FAILURE,
    FETCH_TRIPS_SUBCOVERAGES_REQUEST,
    FETCH_TRIPS_SUBCOVERAGES_SUCCESS,
    FETCH_TRIPS_SUBCOVERAGES_FAILURE,
    FETCH_TRIPS_OBSERVATIONS_REQUEST,
    FETCH_TRIPS_OBSERVATIONS_SUCCESS,
    FETCH_TRIPS_OBSERVATIONS_FAILURE,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS,
    FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS,
    FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE,
    FETCH_TRIP_BY_ID_REQUEST,
    FETCH_TRIP_BY_ID_SUCCESS,
    FETCH_TRIP_BY_ID_FAILURE,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS,
    FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE,
    CREATE_TRIP_REQUEST,
    CREATE_TRIP_SUCCESS,
    CREATE_TRIP_FAILURE,
    CREATE_SUBCOVERAGES_TRIP_REQUEST,
    CREATE_SUBCOVERAGES_TRIP_SUCCESS,
    CREATE_SUBCOVERAGES_TRIP_FAILURE,
    FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST,
    FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS,
    FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE,
    UPDATE_TRIP_REQUEST,
    UPDATE_TRIP_SUCCESS,
    UPDATE_TRIP_FAILURE,
    UPDATE_TRIP_SUBCOVERAGE_REQUEST,
    UPDATE_TRIP_SUBCOVERAGE_SUCCESS,
    UPDATE_TRIP_SUBCOVERAGE_FAILURE,
    DELETE_TRIP_REQUEST,
    DELETE_TRIP_SUCCESS,
    DELETE_TRIP_FAILURE,
    FETCH_TRIP_POLICY_BY_ID_REQUEST,
    FETCH_TRIP_POLICY_BY_ID_SUCCESS,
    FETCH_TRIP_POLICY_BY_ID_FAILURE,
    CHANGE_POLICY_STATUS_REQUEST,
    CHANGE_POLICY_STATUS_SUCCESS,
    CHANGE_POLICY_STATUS_FAILURE,
    FETCH_TRIP_OBSERVATION_REQUEST,
    FETCH_TRIP_OBSERVATION_SUCCESS,
    FETCH_TRIP_OBSERVATION_FAILURE,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS,
    DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE,
    DELETE_TRIP_CHECK_CLAIM_REQUEST,
    DELETE_TRIP_CHECK_CLAIM_SUCCESS,
    DELETE_TRIP_CHECK_CLAIM_FAILURE,
} from '../actions/tripsActions';

const initialState = {
    all: { data: null, loading: false, error: null },
    policies: { data: null, loading: false, error: null },
    claims: { data: null, loading: false, error: null },
    claimsToday: { data: null, loading: false, error: null },
    checkClaims: { data: null, loading: false, error: null },
    forecasts: { data: null, loading: false, error: null },
    observations: { data: null, loading: false, error: null },
    selectedObservation: { data: null, loading: false, error: null },
    subcoveragesTrip: { data: null, loading: false, error: null },
    selectedSubcoverageTrip: { data: null, loading: false, error: null },
    forecastsNotTriggered: { data: null, loading: false, error: null },
    selectedForecastNotTriggered: { data: null, loading: false, error: null },
    selectedTrip: { data: null, loading: false, error: null },
    selectedPolicy: { data: null, loading: false, error: null },
    changePolicyStatus: { loading: false, error: null, success: false },
    create: { loading: false, error: null, success: false },
    createSubcoverages: { loading: false, error: null, success: false },
    subcoveragesByPartner: { data: null, loading: false, error: null },
    update: { loading: false, error: null, success: false },
    updateTripSubcoverage: { loading: false, error: null, success: false },
    delete: { loading: false, error: null, success: false },
    deleteForecastNotTriggered: { loading: false, error: null, success: false },
    deleteCheckClaim: { loading: false, error: null, success: false },
};

const tripsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRIPS_REQUEST:
            return { ...state, all: { data: state.all.data, loading: true, error: null } };
        case FETCH_TRIPS_SUCCESS:
            return { ...state, all: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_FAILURE:
            return { ...state, all: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_POLICIES_REQUEST:
            return { ...state, policies: { data: state.policies.data, loading: true, error: null } };
        case FETCH_TRIPS_POLICIES_SUCCESS:
            return { ...state, policies: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_POLICIES_FAILURE:
            return { ...state, policies: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_CLAIMS_REQUEST:
            return { ...state, claims: { data: state.claims.data, loading: true, error: null } };
        case FETCH_TRIPS_CLAIMS_SUCCESS:
            return { ...state, claims: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_CLAIMS_FAILURE:
            return { ...state, claims: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_CLAIMS_TODAY_REQUEST:
            return { ...state, claimsToday: { data: state.claimsToday.data, loading: true, error: null } };
        case FETCH_TRIPS_CLAIMS_TODAY_SUCCESS:
            return { ...state, claimsToday: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_CLAIMS_TODAY_FAILURE:
            return { ...state, claimsToday: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_CHECK_CLAIMS_REQUEST:
            return { ...state, checkClaims: { data: state.checkClaims.data, loading: true, error: null } };
        case FETCH_TRIPS_CHECK_CLAIMS_SUCCESS:
            return { ...state, checkClaims: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_CHECK_CLAIMS_FAILURE:
            return { ...state, checkClaims: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_FORECASTS_REQUEST:
            return { ...state, forecasts: { data: state.forecasts.data, loading: true, error: null } };
        case FETCH_TRIPS_FORECASTS_SUCCESS:
            return { ...state, forecasts: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_FORECASTS_FAILURE:
            return { ...state, forecasts: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_OBSERVATIONS_REQUEST:
            return { ...state, observations: { data: state.observations.data, loading: true, error: null } };
        case FETCH_TRIPS_OBSERVATIONS_SUCCESS:
            return { ...state, observations: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_OBSERVATIONS_FAILURE:
            return { ...state, observations: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIP_OBSERVATION_REQUEST:
            return { ...state, selectedObservation: { data: null, loading: true, error: null } };
        case FETCH_TRIP_OBSERVATION_SUCCESS:
            return { ...state, selectedObservation: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIP_OBSERVATION_FAILURE:
            return { ...state, selectedObservation: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIPS_SUBCOVERAGES_REQUEST:
            return { ...state, subcoveragesTrip: { data: state.subcoveragesTrip.data, loading: true, error: null } };
        case FETCH_TRIPS_SUBCOVERAGES_SUCCESS:
            console.log('✅ Reducer FETCH_TRIPS_SUBCOVERAGES_SUCCESS - payload:', action.payload);
            return { ...state, subcoveragesTrip: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_SUBCOVERAGES_FAILURE:
            console.error('❌ Reducer FETCH_TRIPS_SUBCOVERAGES_FAILURE - error:', action.payload);
            return { ...state, subcoveragesTrip: { data: null, loading: false, error: action.payload } };

        case FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST:
            return {
                ...state,
                selectedSubcoverageTrip: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS:
            return {
                ...state,
                selectedSubcoverageTrip: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE:
            return {
                ...state,
                selectedSubcoverageTrip: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };

        case FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST:
            return { ...state, forecastsNotTriggered: { data: state.forecastsNotTriggered.data, loading: true, error: null } };
        case FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS:
            return { ...state, forecastsNotTriggered: { data: action.payload, loading: false, error: null } };
        case FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE:
            return { ...state, forecastsNotTriggered: { data: null, loading: false, error: action.payload } };

        case FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST:
            return {
                ...state,
                selectedForecastNotTriggered: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS:
            return {
                ...state,
                selectedForecastNotTriggered: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE:
            return {
                ...state,
                selectedForecastNotTriggered: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case FETCH_TRIP_BY_ID_REQUEST:
            return {
                ...state,
                selectedTrip: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_TRIP_BY_ID_SUCCESS:
            return {
                ...state,
                selectedTrip: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_TRIP_BY_ID_FAILURE:
            return {
                ...state,
                selectedTrip: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case CREATE_TRIP_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_TRIP_SUCCESS:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case CREATE_TRIP_FAILURE:
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case CREATE_SUBCOVERAGES_TRIP_REQUEST:
            return {
                ...state,
                createSubcoverages: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_SUBCOVERAGES_TRIP_SUCCESS:
            return {
                ...state,
                createSubcoverages: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case CREATE_SUBCOVERAGES_TRIP_FAILURE:
            return {
                ...state,
                createSubcoverages: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST:
            return {
                ...state,
                subcoveragesByPartner: {
                    data: state.subcoveragesByPartner.data,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS:
            return {
                ...state,
                subcoveragesByPartner: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE:
            return {
                ...state,
                subcoveragesByPartner: {
                    data: state.subcoveragesByPartner.data,
                    loading: false,
                    error: action.payload,
                },
            };

        case UPDATE_TRIP_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_TRIP_SUCCESS:
            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case UPDATE_TRIP_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case UPDATE_TRIP_SUBCOVERAGE_REQUEST:
            return {
                ...state,
                updateTripSubcoverage: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_TRIP_SUBCOVERAGE_SUCCESS:
            return {
                ...state,
                updateTripSubcoverage: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case UPDATE_TRIP_SUBCOVERAGE_FAILURE:
            return {
                ...state,
                updateTripSubcoverage: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_TRIP_REQUEST:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_TRIP_SUCCESS:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
                // Retirer le séjoursupprimé de la liste
                all: {
                    ...state.all,
                    data: state.all.data ? {
                        ...state.all.data,
                        trips: state.all.data.trips ? state.all.data.trips.filter(trip => {
                            const tripId = trip.activity_id || trip.id;
                            return tripId !== action.payload;
                        }) : state.all.data.trips,
                        records: state.all.data.records ? state.all.data.records.filter(trip => {
                            const tripId = trip.activity_id || trip.id;
                            return tripId !== action.payload;
                        }) : state.all.data.records,
                    } : state.all.data,
                },
            };

        case DELETE_TRIP_FAILURE:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case FETCH_TRIP_POLICY_BY_ID_REQUEST:
            return {
                ...state,
                selectedPolicy: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_TRIP_POLICY_BY_ID_SUCCESS:
            return {
                ...state,
                selectedPolicy: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_TRIP_POLICY_BY_ID_FAILURE:
            return {
                ...state,
                selectedPolicy: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case CHANGE_POLICY_STATUS_REQUEST:
            return {
                ...state,
                changePolicyStatus: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CHANGE_POLICY_STATUS_SUCCESS:
            return {
                ...state,
                changePolicyStatus: {
                    loading: false,
                    error: null,
                    success: true,
                },
                // Mettre à jour le statut dans selectedPolicy si la police est actuellement chargée
                selectedPolicy: state.selectedPolicy.data ? {
                    ...state.selectedPolicy,
                    data: {
                        ...state.selectedPolicy.data,
                        policies_info: {
                            ...state.selectedPolicy.data.policies_info,
                            status: action.payload.status || state.selectedPolicy.data.policies_info?.status,
                        },
                    },
                } : state.selectedPolicy,
            };

        case CHANGE_POLICY_STATUS_FAILURE:
            return {
                ...state,
                changePolicyStatus: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST:
            return {
                ...state,
                deleteForecastNotTriggered: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS:
            return {
                ...state,
                deleteForecastNotTriggered: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE:
            return {
                ...state,
                deleteForecastNotTriggered: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_TRIP_CHECK_CLAIM_REQUEST:
            return {
                ...state,
                deleteCheckClaim: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_TRIP_CHECK_CLAIM_SUCCESS:
            return {
                ...state,
                deleteCheckClaim: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case DELETE_TRIP_CHECK_CLAIM_FAILURE:
            return {
                ...state,
                deleteCheckClaim: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        default:
            return state;
    }
};

export default tripsReducer;



